export default __webpack_public_path__ + "static/media/category_d1e.836872bd.svg";